import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-reviews',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map